// eslint-disable-next-line import/prefer-default-export
export const isTrimmedEmpty = (string: string): boolean => {
  if (!string) {
    return true;
  }
  return !string.trim();
};
